import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 sm:py-32 px-4 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/399b1cb19bae31c05fc7c2dd6191d5eb.jpg"
          alt="Cosmic Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-5xl md:text-7xl font-display font-black text-white mb-4 sm:mb-6 uppercase tracking-tight">
          토큰이 부족합니다
        </h2>

        <p className="text-base sm:text-xl md:text-2xl text-white mb-8 sm:mb-12 leading-relaxed">
          더 많은 운명 리딩을 위해 토큰을 충전하세요
        </p>

        <Link
          to="/checkout"
          className="inline-flex items-center gap-3 sm:gap-4 px-8 sm:px-12 py-4 sm:py-5 bg-black rounded-full text-white font-bold text-base sm:text-lg hover:bg-primary-gold hover:text-primary-dark transition-all group cursor-pointer whitespace-nowrap"
        >
          <div className="w-9 h-9 sm:w-12 sm:h-12 rounded-full bg-gold-gradient flex items-center justify-center flex-shrink-0">
            <i className="ri-vip-diamond-fill text-primary-dark text-lg sm:text-2xl"></i>
          </div>
          <span className="uppercase tracking-wide">토큰 충전하기</span>
          <i className="ri-arrow-right-up-line text-xl sm:text-2xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
        </Link>
      </div>
    </section>
  );
}
